import React from 'react'

import PropTypes from 'prop-types'

import './hero8.css'

const Hero8 = (props) => {
  return (
    <div className="hero8-header26 thq-section-padding">
      <div className="hero8-max-width thq-flex-column thq-section-max-width">
        <div className="hero8-column">
          <div className="hero8-content">
            <h1 className="hero8-text thq-heading-1">{props.heading1}</h1>
            <p className="hero8-text1 thq-body-large">{props.content1}</p>
            <div className="hero8-actions">
              <a
                href="/courses"
                className="hero8-button thq-button-animated thq-button-outline">
                <span className="hero8-text1 thq-body-small">
                {props.action1}
                </span>
              </a>
            </div>
          </div>
        </div>
        <img
          alt={props.image1Alt}
          src={props.image1Src}
          className="thq-img-ratio-16-9"
        />
      </div>
    </div>
  )
}

Hero8.defaultProps = {
  action1: 'Get Started',
  heading1: 'Amit world academy',
  image1Alt: 'Illustration of people learning online',
  image1Src: '/hero8.png',
  action2: 'Explore Courses',
  content1: 'Unlock Your Potential with Expert-Led Courses!',
}

Hero8.propTypes = {
  action1: PropTypes.string,
  heading1: PropTypes.string,
  image1Alt: PropTypes.string,
  image1Src: PropTypes.string,
  action2: PropTypes.string,
  content1: PropTypes.string,
}

export default Hero8
